import { createContext, useContext, useState } from 'react';

export const MonitoramentoGeralContext = createContext();

export const MonitoramentoGeralContextProvider = ({ children }) => {

    const [isDataWarningActive, setIsDataWarningActive] = useState(true);
    const [alarmsCompressores, setAlarmsCompressores] = useState([]);

    return (
        <MonitoramentoGeralContext.Provider value={{ isDataWarningActive, setIsDataWarningActive, alarmsCompressores, setAlarmsCompressores }}>
            {children}
        </MonitoramentoGeralContext.Provider>
    );
};

export function useMonitoramentoGeralContext() {
    return useContext(MonitoramentoGeralContext);
}

export const usePageConfig = useMonitoramentoGeralContext;
